import React from "react";

import logo from "../../../assets/Images/logo-noordhen.svg";

import { Spinner } from "react-og-loaders";

import { Container } from "./styles";

const Loading = () => {
    return (
        <Container>
            <img src={logo} alt="Noordhen Brasil Loading" />

            <Spinner color="var(--primary)" size={42} />
        </Container>
    );
};

export default Loading;
